import React, { useState, } from 'react'
import { Form, Input, Button, Row, Checkbox, Typography, message, Flex, } from 'antd';
import { useApp } from '../../context/app-context';
import { useNavigate, Link } from "react-router-dom"
import ReCAPTCHA from 'react-google-recaptcha';
import DynamicTable from '../../components/Auth/SignUp/DynamicTable'
import { createCustomer } from '../../services/UserService';
import { isValidPhoneNumber, validatePhoneNumber, maskPhoneNumber, isValidEmail, } from '../../Validation';
import './Auth.css';

const { Title, Text, } = Typography;

export const SignUp = () => {

    const {state: {auth}, dispatch} = useApp();
    const navigate = useNavigate();
    const [isVerified, setIsVerified] = useState(false);
    const [dataSource, setDataSource] = useState([]);

    const formatDataSource = (clouds) => {
        let values = []
        clouds.forEach((cloud)=>{
            values.push(cloud.serialNum)
        })
        return values
    }

    const onChange = (value) => {
        setIsVerified(true);
    };

    const onFinish = (values) => {
        let clouds = formatDataSource(dataSource);
        Object.assign(values, 
            // {username: values.email, cloudIDs: clouds, quantity: -1, registeredUser: true}
            {  
                username: values.email, 
                email: values.email, 
                cloudIDs: [], 
                quantity: -1, 
                registeredUser: true
            }
        );

        createCustomer(values).then( function (data) {
            if(data.status === 'success'){
                message.success("User registered successfully, please check you email. You will be redirected to the login page...", 5)
                setTimeout(() => {
                    navigate('/')
                }, 5000);
            } else if (data.error){
                message.error(data.message, 5)
            }
        })
    };

    return (
        <div>
            <Row justify="center">
                <Form
                    name="sign-up"
                    className="form-container"
                    initialValues={{ remember: true }}
                    onFinish={(values) => onFinish(values)}
                    layout='vertical'
                    autoComplete='off'
                    >   
                    <Title level={1}>Sign up</Title>

                    <Form.Item
                        name='firstName'
                        label='First name:'
                        rules={[{ required: true, message: "First name required" }]}
                        >
                        <Input type="text"/>
                    </Form.Item>

                    <Form.Item
                        name='lastName'
                        label='Last name:'
                        rules={[{ required: true, message: "Last name required" }]}
                        >
                        <Input type="text"/>
                    </Form.Item>
                    <Form.Item
                        hasFeedback
                        name="email"
                        label='Username / Email address:'
                        rules={[
                            {
                                required: true,
                                message: 'Email address required',
                            },
                            {
                                type: 'email',
                                validator: (rule, value) => {
                                    
                                    if(!rule.required && !value){
                                        return Promise.resolve();
                                    }

                                    if (value && isValidEmail(value)) {
                                        return Promise.resolve();
                                    }
                                    
                                    return Promise.reject(new Error('Please enter a valid email address'));
                                }
                            },
                        ]}
                        >
                        <Input type="email"/>
                    </Form.Item>
                    <Form.Item
                        hasFeedback
                        name="phone"
                        label='Phone number:'
                        rules={[
                                {
                                    required: true,
                                    message: 'Phone number required',
                                },
                                {
                                    type: "tel", 
                                    validator: (rule, value) => {
                                        if(!rule.required && !value){
                                            return Promise.resolve();
                                        }

                                        if(validatePhoneNumber(value) && isValidPhoneNumber(value)){
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Please enter valid phone number'));
                                    }
                                }, 
                            ]}
                        >
                        <Input onInput={(e) => maskPhoneNumber(e) }/>
                    </Form.Item>
                    <Form.Item
                        label='Company:'
                        rules={[{ required: true, message: "Company name can't be blank" }]}
                        >
                        <Input type="text"/>
                    </Form.Item>
                    <Form.Item
                        label='Site name:'
                        rules={[{ required: true, message: "Site can't be blank" }]}
                    >
                        <Input type="text"/>
                    </Form.Item>
                    <Form.Item
                        name="agree"
                        valuePropName="checked"
                        rules={[
                        {
                            message: "You must accept the terms and conditions to register an account.",
                            validator: (_, value) =>
                                value ? Promise.resolve() : Promise.reject(new Error('Should accept agreement')),
                            },
                        ]}
                    >   
                        <Checkbox>I have read and agree to the <strong><Text underline><a href='https://www.avalannetworks.com/cloud-legal' target='_blank' rel="noreferrer">Terms and Conditions</a></Text></strong> of this site.</Checkbox>
                    </Form.Item>
                    <Form.Item
                        name="captcha"
                        rules={[{ required: true, message: "reCAPTCHA is required" }]}
                        >
                        <ReCAPTCHA
                            sitekey="6LcbxX0pAAAAAAeJj9jjINonicotInsZ6te4pp0w"
                            onChange={onChange}
                        />
                    </Form.Item>

                    {/* <Form.Item 
                        name="cloudID"
                        >
                        <DynamicTable dataSource={dataSource} setDataSource={setDataSource}></DynamicTable>
                    </Form.Item> */}
                    

                    <Flex justify='center' vertical gap='large'>
                        <Button type="primary" htmlType="submit" block className="btn-block">Sign Up</Button>
                        <p align="center"> Already have an account? <Link to='/'><strong>Sign In</strong></Link></p>
                    </Flex>
                </Form>
            </Row>
        </div>
    )
}
